import { useQueryClient } from '@tanstack/react-query';
import { http } from 'services/http';
import { ADDITIONAL_COSTS_GET_MANY } from 'api/query-keys';
import { useMutationBase } from 'shared/hooks/use-mutation-base';

export const useDeleteAllAdditionalCostsFromTrip = (tripId: number) => {
  const queryClient = useQueryClient();

  return useMutationBase<unknown, unknown, number>({
    mutationFn: async (id) => {
      const res = await http.delete(`/v1/additional-costs/trips/${id}`);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [ADDITIONAL_COSTS_GET_MANY, String(tripId)] });
    },
  });
};
